import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    companyList: [],
    companyListCount: null,
    companyFilter: {
        main_filter: null,
        fields: {
            companyNumber: null,
            companyTitle: null,
            companyType: null,
            companyManager: null,
            companyStatus: null,
        },
    },
    companyModalOpen: false,
    topUpBalanceCompanyModalOpen: false,
    buySignaturesCompanyModalOpen: false,
    modalVerifyCompanyFormOpen: false,
    company_id: null,
    company_index: null,
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}
